'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voter-group-show', {
      url: '/voter-group/:id',
      template: '<voter-group-show></voter-group-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/voter-group-show/voter-group-show.routes.js